import { EMERGENCY_BAND_DEFAULT_MESSAGE, EmergencyBand } from './emergency-band';
import type { ComponentConfig } from "@puckeditor/core";
import { EmergencyBandFields } from "./emergency-band.fields";
import type { EmergencyBandProps } from './emergency-band';
import type { JobsiteBusinessContext } from '../../types/runtime-config';
import { getWindowJobsiteConfig } from '../../types/runtime-config';

/**
 * The claim has exactly one writer: `Business.emergencyService`, set in Business
 * settings. So there is no field for it here, and none for the phone either.
 *
 * That absence is the enforcement. An editor toggle would be a second writer for
 * a fact that already has one, and the two would eventually disagree — which is
 * how `urgencyLevel` ended up offering a "Service Urgency" dropdown that changed
 * nothing for months.
 */
const EmergencyBandConfig: ComponentConfig<EmergencyBandProps> = {
  defaultProps: {
    message: EMERGENCY_BAND_DEFAULT_MESSAGE,
    variant: "standard",
  },
  fields: {
    message: { ...EmergencyBandFields.message, contentEditable: true },
    variant: EmergencyBandFields.variant,
  },
  label: "Emergency Band",
  render: ({ id, puck, editMode, ...props }) => {
    const puckMetadata = puck?.metadata as { business?: JobsiteBusinessContext } | undefined,
      windowConfig = getWindowJobsiteConfig(),
      business = puckMetadata?.business || windowConfig?.business;

    return (
      <EmergencyBand
        id={id}
        {...props}
        // Read at render, in both directions, so turning the toggle off in
        // Settings removes the band without regenerating the site.
        emergencyService={business?.emergencyService ?? null}
        phone={business?.emergencyPhone || business?.phone || business?.telephone || ""}
        // Puck defaultProps aren't applied when the generator writes a page, so
        // The fallback has to live here too.
        message={props.message || EMERGENCY_BAND_DEFAULT_MESSAGE}
        isEditing={Boolean(windowConfig?.isEditing ?? editMode)}
        navFixed={windowConfig?.navigationStyle === "transparent"}
      />
    );
  },
};

export { EmergencyBandConfig };
